

export const LIVESESSION_SOCKET_URL = 'wss://websocket.test.viliyo.com';
export const MEDIASTREAM_SOCKET_URL = 'wss://stream.test.viliyo.com';

// export const LIVESESSION_SOCKET_URL = 'wss://test.akashkumarshukla.in/';
// export const MEDIASTREAM_SOCKET_URL = 'wss://openvidustream.akashkumarshukla.in/protoo?roomId=4830&peerId=nayan.singh@viliyo.com'